import { Link } from "react-router-dom";
//import "./DestinationCard.scss";

export default function DestinationCard({ destination }) {
  return (
    <Link to={`/journeys/${destination.slug}`} className="destination-card">
      <img src={destination.thumbnailImage} alt={destination.title} />

      <div className="destination-card__overlay" />

      <div className="destination-card__content">
        <h3>{destination.title}</h3>
        <span>
          {destination.region}
          {destination.country && `, ${destination.country}`}
        </span>
      </div>
    </Link>
  );
}
